<template>
  <div class="contact-div">
    <MenuSide></MenuSide>
    <div> <!-- :style="{ 'background-image': 'url(' + backgroundImage + ')' }" class="contact-image"-->
     <div class="contact-textdiv">
       <h1 class="contact-title">DON'T BE SHY!</h1>
       <h5 class="contact-title-small">Leave your details & we'll get back to you soon to discuss your project</h5>
       <img v-if="!this.isMobile" class="menu-mobile-div" src="/static/img/global/purple-line.svg">

       <form @submit.prevent="submit">
       <div class="group">

         <input class="magic-input" v-model="contactForm.fullName" required placeholder='Full name' type='text'></input>
         <input class="magic-input" v-model="contactForm.email" required placeholder='Email' type='email' ></input>
         <input class="magic-input label-phone" v-model="contactForm.phone" required placeholder='Phone' type='text' ></input>
         <textarea class="magic-input area" name="message" placeholder="Write us something…" required v-model="contactForm.content"></textarea>

       </div>
       <button class="contact-us-submit-button" type="submit">LET'S TALK</button>
       </form>
     </div>
    </div>
    <div class="map-wrapper">
      <div v-if="!this.isMobile" class="map-title">
          <div class="menu-address2">
            +972-3-6565400 | Marketing@hippotec.com
            25, Ha-sivim st., Petah Tikva, Israel
          </div>
          <div class="menu-social-line2">
            <a href="https://www.facebook.com/hippotec.mobile/">
              <img class="menu-social-line-item" src="/static/img/global/menu-facebook-white.svg">
            </a>
            <a href="https://www.linkedin.com/company/hippotec-ltd-/about/">
              <img class="menu-social-line-item" src="/static/img/global/menu-linkedin-white.svg">
            </a>
            <a href="https://www.instagram.com/hippotec_ltd/">
              <img class="menu-social-line-item" src="/static/img/global/menu-instagram-white.svg">
            </a>
          </div>
      </div>
      <div v-else class="map-title">
        <div class="menu-address2">
          +972-3-6565400 <br>
          Marketing@hippotec.com <br>
          25, Ha-sivim st., Petah Tikva, Israel
        </div>
        <div class="menu-social-line">
          <a href="https://www.facebook.com/hippotec.mobile/">
            <img class="menu-social-line-item" src="/static/img/global/menu-facebook-white.svg">
          </a>
          <a href="https://www.linkedin.com/company/hippotec-ltd-/about/">
            <img class="menu-social-line-item" src="/static/img/global/menu-linkedin-white.svg">
          </a>
          <a href="https://www.instagram.com/hippotec_ltd/">
            <img class="menu-social-line-item" src="/static/img/global/menu-instagram-white.svg">
          </a>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import MagicVueInput from 'magic-vue-input'
  import bg from '../../static/img/pic.png'
  import bgmobile from '../../static/img/picmobile.png'
  //import ContactUs from './../components/ContactUs'
  //import MenuSide from './../components/MenuSide'
  import MenuSide from '@bit/hippotec.website2019.menu-side';
  import backgroundmobileimage from "../../static/img/banners/adult-agency-business2.8edc0c5.jpg";

  export default {
    name: 'Contact',
    data() {
      return {
        isError: false,
        contactForm: {
          fullName: '',
          email: '',
          phone: '',
          content: ''
        },
          backgroundImage: bg,
        window
      }
    },
    methods: {
      submit() {
        let part1 = '<html><body>Email: ';
        let part2 = '<br> Full name: ';
        let part3 = '<br> Phone: ';
        let part4 = '<br> Message: ';
        let part5 = '</body></html>';
        let sendForm = {
          fullName: this.contactForm.fullName,
          content: part1 + this.contactForm.email + part2 + this.contactForm.fullName + part3 + this.contactForm.phone + part4 + this.contactForm.content + part5
        }
        this.$http.post('http://54.89.99.189:3011/message', sendForm)
          .then((data) => {
              this.contactForm = {
                fullName: '',
                  email: '',
                  phone: '',
                  content: ''
              };
              alert("Success");
            },
            function (data) {
              console.log('Error: ' + JSON.stringify(data));
              alert(JSON.stringify(data));
            }
          )
      },
      prepareMobile(isMobile) {
        //console.log(isMobile);
        this.isMobile = isMobile;
        if (isMobile) {

        }
      }
    },
    components: {
      MagicVueInput:  MagicVueInput,
      //ContactUs: ContactUs,
      MenuSide: MenuSide
    },
    created() {
      this.backgroundImage = window.innerWidth > 600 ? bg : bgmobile
      this.prepareMobile(localStorage.isMobile == 'true');
    }
  }

</script>
<style lang="scss" scoped>
  @import "../assets/scss/contact.scss";
  .address-table {

  }
  .menu-table-left {
    width: 10%;
    background: #009929;
  }
  .menu-table-right {
    width: 10%;
    background: #fc497d;
  }
  .menu-address2 {
    width: 367px;
    height: 62px;
    font-family: Rubik, sans-serif;
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.72;
    letter-spacing: normal;
    color: var(--white);
  }
  .menu-social-line2 {
    margin-left: 240px;
    display: flex;
  }
  .menu-social-line-item {
    margin-right: 10px;
    height: 42px;
    width: 42px;
  }
  .contact-title
  {
    font-family: Rubik, sans-serif;
    font-size: 60px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    //line-height: 0.65;
    letter-spacing: normal;
    text-align: center;
  }
  .contact-title-small {
    font-family: Rubik, sans-serif;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    color: #392160;
  }
  .contact-textdiv
  {
    width: 500px;
    display: block;
    padding-top: 6%;
    text-align: center;
  }
  .map-wrapper {
    margin-top: 70px;
  }
  .map {
    max-width:100%;
    height:auto;
  }
  .map-title {
    height: 137px;
    width: 100%;
    z-index:2;
    position:absolute;
    background-color: rgba(68, 46, 115, 0.9);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .contact-us-submit-button {
    margin-top: 20px;
    width: 150px;
    height: 40px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    font-weight: 500;
    border-radius: 3px;
    background: #514077;
    border: 1px solid #fff
  }

  .group {
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;

    .magic-input{
      border: 1px solid #523d83 ;
      padding: 25px 15px 25px 15px;
      margin: 8px 0;
      margin-top: 30px;
    }
    .area {
      min-height: 150px;
    }
    .magic-input::placeholder {
      font-family: Rubik, sans-serif;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #bcbcbc;
    }
    .label-phone {
      //margin-top: 25px;
    }
    .line {
      width: 100%;
      height: 1px;
      border: solid 1px #BDBFC1;
    }

    label {
      margin-top: 25px;
      color: #6c4077;
      display: block;
      text-align: left;
      font-size: 14px;
    }
    input {
      margin-top: 20px;
      width: 100%;
      float: left;
      height: 25px;
      border-radius: 2.7px;
      border: 1px solid transparent;
    }
    .error {
      color: red;
      font-family: Rubik, sans-serif;
      font-size: 14px;
      text-align: left;
    }

    textarea {
      width: 100%;
      padding-top: 26px;
      padding-bottom: 15px;
      min-height: 100px;
      border-radius: 2.7px;
      background-color: #fbfbfb;
      border: 1px solid transparent;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue